import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get, isNil } from 'lodash';
import { ConnectWidget } from '@mxenabled/web-widget-sdk';

import { parseUrlParams } from 'utils/parseUrlParams';
import imgError from 'assets/images/error.svg';
import {
  newNextAction,
  NEW_NEXT,
  randomNextAction,
  RANDOM_NEXT,
} from 'actions/navigation';
import Transition from 'components/Transition';
import Header from 'components/Header';
import Modal from 'components/Modal';
import { useConfig } from 'config/ConfigContext';
import './style.scss';
import { PuffLoader } from 'react-spinners';

const MXVerification = (props) => {
  const config = useConfig();
  const { checkinData, dispatch, navigate, fetch } = props;
  const [errorMessage, setErrorMessage] = useState(null);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const mxContainerRef = useRef(null);
  const widgetRef = useRef(null);
  const params = parseUrlParams(window.location.search);

  const handleMxSuccess = (data) => {
    setIsLoading(true);
    setErrorMessage(null);

    if (params.key) {
      dispatch(newNextAction({
        key: params.key,
        workflowType: 'mx',
        data: {
          userGuid: get(data, 'user_guid'),
          memberGuids: [get(data, 'member_guid', '')],
        },
        fail: (err) => {
          console.log(err);
          setIsPopupVisible(true);
          setErrorMessage(get(err, 'data.message'));
          setIsLoading(false);
        },
      }));
    }
  };

  useEffect(() => {
    const sourceData = get(checkinData, 'data');
    if (isNil(sourceData)) {
      navigate(`/mx/welcome/?key=${params.key}`);
      return;
    }

    const mxUrl = get(checkinData, 'data.mxUrl') || get(checkinData, 'state.mxUrl');
    if (mxUrl && mxContainerRef.current) {
      widgetRef.current = new ConnectWidget({
        url: mxUrl,
        container: mxContainerRef.current,
        style: {
          width: '100%',
          height: '100%',
          marginTop: '2px',
        },
        onMemberConnected: handleMxSuccess,
        onError: () => {
          setIsPopupVisible(true);
        },
      });

      return () => {
        if (widgetRef.current && widgetRef.current.destroy) {
          widgetRef.current.destroy();
        }
      };
    }
  }, [props.checkinData]);

  useEffect(() => {
    if (fetch.isDone[`${RANDOM_NEXT}`] && !fetch.isRunning[`${RANDOM_NEXT}`]) {
      if (get(checkinData, 'data.data.nextAction.path') || get(checkinData, 'state.data.nextAction.path')) {
        dispatch(randomNextAction({
          rawUrl: get(checkinData, 'data.data.nextAction.path') || get(checkinData, 'state.data.nextAction.path'),
          data: {},
        }));
      } else if (get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path')) {
        dispatch(randomNextAction({
          rawUrl: get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path'),
          data: {},
        }));
      } else if (get(checkinData, 'data.url') || get(checkinData, 'state.url')) {
        const url = get(checkinData, 'data.url') || get(checkinData, 'state.url');
        const routeUrl = url.replace(config.hostUrl, '');
        navigate(routeUrl);
      }
    } else if (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) {
      if (get(checkinData, 'data.data.nextAction.path') || get(checkinData, 'state.data.nextAction.path')) {
        dispatch(randomNextAction({
          rawUrl: get(checkinData, 'data.data.nextAction.path') || get(checkinData, 'state.data.nextAction.path'),
          data: {},
        }));
      } else if (get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path')) {
        dispatch(randomNextAction({
          rawUrl: get(checkinData, 'data.nextAction.path') || get(checkinData, 'state.nextAction.path'),
          data: {},
        }));
      } else if (get(checkinData, 'data.url') || get(checkinData, 'state.url')) {
        const url = get(checkinData, 'data.url') || get(checkinData, 'state.url');
        const routeUrl = url.replace(config.hostUrl, '');
        navigate(routeUrl);
      }
    }
  }, [props.checkinData]);

  const handleClosePopup = () => {
    setIsPopupVisible(false);
    navigate(0);
  };

  return (
    <Transition className="transition-item wrapper vh-100 mx-wrapper">
      <Header />
      <div className="content">
        <div ref={mxContainerRef} className="mx-widget-container" style={{ display: isPopupVisible ? 'none' : 'block' }} />
      </div>
      {isLoading && (
        <div className="loading-wrapper">
          <PuffLoader
            size={100}
            color="#0084f6"
          />
        </div>
      )}
      {
        isPopupVisible
          && (
          <Modal>
            <div className="card-content error-modal security-error">
              <img src={imgError} alt="" />
              <p>{errorMessage || 'Something went wrong. Please try again.'}</p>
              <div onClick={handleClosePopup} className="btn btn-red">OK</div>
            </div>
          </Modal>
          )
      }
    </Transition>
  );
};

MXVerification.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  fetch: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(MXVerification);
